const e=e=>e.type===`object`,t=e=>e.type===`string`&&`enum`in e&&Array.isArray(e.enum)&&e.enum.length>0;export{t as isEnumSchema,e as isObjectSchema};
//# sourceMappingURL=type-guards.js.map